"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";
import { useFeedback } from "@nyntax/design-system/feedback";
import { cn } from "@nyntax/design-system/lib/utils";
import { LuCheck, LuX } from "react-icons/lu";

function Switch({
  className,
  size = "default",
  onCheckedChange,
  ...props
}: SwitchPrimitive.Root.Props & {
  size?: "sm" | "default";
}) {
  const { play } = useFeedback();

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      onCheckedChange={(checked, event) => {
        play(checked ? "toggle-on" : "toggle-off");
        onCheckedChange?.(checked, event);
      }}
      className={cn(
        "data-checked:bg-primary data-unchecked:bg-input focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 dark:data-unchecked:bg-input/80 peer group/switch hit-area-x-3 hit-area-y-2 inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none focus-visible:ring-3 aria-invalid:ring-3 data-disabled:cursor-not-allowed data-disabled:opacity-50 data-[size=default]:h-[18.4px] data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px]",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="bg-background dark:data-unchecked:bg-foreground dark:data-checked:bg-primary-foreground pointer-events-none relative block rounded-full ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0"
      >
        <span
          aria-hidden="true"
          className="text-muted-foreground absolute inset-0 flex items-center justify-center transition-opacity duration-200 ease-in group-data-checked/switch:opacity-0 group-data-checked/switch:duration-100 group-data-checked/switch:ease-out"
        >
          <LuX
            className="size-2.5 group-data-[size=sm]/switch:size-2"
            strokeWidth={2.5}
          />
        </span>
        <span
          aria-hidden="true"
          className="text-primary absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-100 ease-out group-data-checked/switch:opacity-100 group-data-checked/switch:duration-200 group-data-checked/switch:ease-in"
        >
          <LuCheck
            className="size-2.5 group-data-[size=sm]/switch:size-2"
            strokeWidth={3}
          />
        </span>
      </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
  );
}

export { Switch };
